var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('v-card',[_c('v-img',{attrs:{"alt":_vm.alt,"src":_vm.src,"contain":"","max-height":"200","max-width":"200"}})],1):_c('v-progress-circular',{attrs:{"indeterminate":""}})}
var staticRenderFns = []

export { render, staticRenderFns }